import classNames from "classnames";

import { translate } from "@ascendnow/shared";

import { ReactComponent as OopsIcon } from "../../assets/icons/oops.svg";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import AscParagraph from "../AscTypography/AscParagraph/AscParagraph";
import AscButton from "../AscButton/AscButton";
import { AscErrorViewProps, ErrorObj } from "./AscErrorView.type";
import styles from "./AscErrorView.module.scss";

const errorObj: ErrorObj = {
  500: {
    title: translate("internalServerError"),
    description: translate("somethingWentWrong"),
  },
  404: {
    title: translate("pageNotFound"),
    description: translate("somethingWentWrong"),
  },
};

export default function AscErrorView({
  error,
  onRedirect,
  redirectText = translate("goBackHome"),
  title = translate("oops"),
  description = translate("somethingWentWrong"),
  className,
}: AscErrorViewProps) {
  return (
    <div
      data-testid="asc-error-custom"
      className={classNames(styles.ground, className)}
    >
      <OopsIcon />
      <div className={styles.text}>
        <AscHeading level={2} className={styles.title}>
          {error !== "custom" ? errorObj[error].title : title}
        </AscHeading>
        <AscParagraph className={styles.description}>
          {error !== "custom" ? errorObj[error].description : description}
        </AscParagraph>
      </div>
      <AscButton onClick={onRedirect}>{redirectText}</AscButton>
    </div>
  );
}
